import React, { useState } from 'react';
import { FadeIn } from './FadeIn';
import { ChevronDown } from 'lucide-react';
import { motion, AnimatePresence } from 'framer-motion';
export function FAQ() {
  const faqs = [{
    q: '¿Cómo se recibe el material?',
    a: 'Una vez confirmada la compra accedés al material en formato digital para descargar de inmediato.'
  }, {
    q: '¿Es un producto físico?',
    a: 'No, es un producto 100% digital en PDF.'
  }, {
    q: '¿Necesito editar algo antes de imprimirlo?',
    a: 'No. Está pensado para imprimir y usar directamente en la sesión.'
  }, {
    q: '¿Sirve para consultorio y para escuela?',
    a: 'Sí. Puede utilizarse en consultorio, escuela, acompañamiento e intervención individual.'
  }, {
    q: '¿Está pensado solo para niños pequeños?',
    a: 'No. Está organizado para trabajar con niños desde los 7 años hasta adolescentes, en tres franjas etarias.'
  }, {
    q: '¿Los tomos incluyen herramientas prácticas?',
    a: 'Sí. Todos los tomos incluyen plantillas, recursos visuales y propuestas listas para aplicar.'
  }, {
    q: '¿Tiene garantía?',
    a: 'Sí, 7 días de garantía con devolución total.'
  }];
  const [openIdx, setOpenIdx] = useState<number | null>(0);
  return <section className="py-10 px-3 max-w-3xl mx-auto" data-id="element-53">
      <FadeIn data-id="element-54">
        <h2 className="font-display text-xl md:text-2xl font-bold text-accent text-center mb-8" data-id="element-55">
          Preguntas frecuentes
        </h2>
      </FadeIn>

      <div className="space-y-3" data-id="element-56">
        {faqs.map((faq, idx) => <FadeIn key={idx} delay={idx * 0.1} data-id="element-57">
            <div className="bg-surface/60 rounded-lg border border-accent/20 overflow-hidden" data-id="element-58">
              <button onClick={() => setOpenIdx(openIdx === idx ? null : idx)} className="w-full text-left px-5 py-4 flex items-center justify-between font-bold text-ink text-sm hover:bg-accent/5 transition-colors" data-id="element-59">
                <span className="pr-4" data-id="element-60">{faq.q}</span>
                <ChevronDown className={`shrink-0 text-accent transition-transform duration-300 ${openIdx === idx ? 'rotate-180' : ''}`} size={18} data-id="element-61" />
              </button>
              <AnimatePresence data-id="element-62">
                {openIdx === idx && <motion.div initial={{
              height: 0,
              opacity: 0
            }} animate={{
              height: 'auto',
              opacity: 1
            }} exit={{
              height: 0,
              opacity: 0
            }} transition={{
              duration: 0.3
            }} data-id="element-63">
                    <div className="px-5 pb-4 text-muted text-sm leading-relaxed" data-id="element-64">
                      {faq.a}
                    </div>
                  </motion.div>}
              </AnimatePresence>
            </div>
          </FadeIn>)}
      </div>
    </section>;
}